module.exports = __webpack_public_path__ + "static/media/logoDesign.b41f1706.png";